import Checkbox from '@/app/components/common/Checkbox'
import Text from '@/app/components/common/Text'
import { STARS } from '@/app/constants'
import { Filters } from '@/app/types'
import { useTranslations } from 'next-intl'
import { FC, useMemo } from 'react'

interface StarRatingFilterProps {
	localValue: Filters
	availableFilters: { [key: string]: number }
	handleStarChange: (star: number, track: boolean) => void
}

const StarRatingFilter: FC<StarRatingFilterProps> = ({
	localValue,
	availableFilters,
	handleStarChange,
}) => {
	const t = useTranslations('Keywords')

	const availableStars = useMemo(
		() => STARS.filter((star) => availableFilters[star] > 0),
		[availableFilters]
	)

	if (availableStars.length === 0) {
		return null
	}

	const getStarLabel = (starCount: number): string => {
		return starCount === 1 ? t('oneStarHotels') : t('starHotels', { starCount })
	}

	const handleCheckboxChange = (star: number) => {
		handleStarChange(star, true)
	}

	return (
		<div className="hotel-list-filters__section">
			<Text size="lg" font="semibold" className="hotel-list-filters__title">
				{t('starRatingFilter')}
			</Text>
			<div className="hotel-list-filters__stars">
				{availableStars.map((star) => {
					const starLabel = getStarLabel(star)
					const hotelCount = availableFilters[star]
					const isChecked = localValue.stars.includes(star)

					return (
						<div
							key={star}
							className="hotel-list-filters__stars-star hotel-list-filters__item"
						>
							<Checkbox
								variant="main-dark"
								checked={isChecked}
								testId={`star-${star}`}
								onChange={() => handleCheckboxChange(star)}
								labelRight={`${starLabel} (${hotelCount})`}
								bold={false}
							/>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default StarRatingFilter
